export default __webpack_public_path__ + "static/11x17_AQPPaginaDeActividad-74498879c68d3c0291340b1f3ef71976.pdf";